import React from "react";
import ProjectDetails from "../projectDetails/ProjectDetails";

export default ({
  isLoading,
  handleOnClick,
  toggle,
  callApiOnSuccess,
  isProjectAwardedByState,
  calledFromIssueDetail,
  handleOnClickStatus
}) => {
  return (
    <div>
      <ProjectDetails
        handleOnClick={handleOnClick}
        handleOnClickStatus={handleOnClickStatus}
        toggle={toggle}
        isProjectAwardedByState={isProjectAwardedByState}
        callApiOnSuccess={callApiOnSuccess}
        calledFromIssueDetail={calledFromIssueDetail}
      />
    </div>
  );
};
